import { Button } from "#/components/ui/button";

interface EndTurnButtonProps {
  onClick: () => void | Promise<void>;
  disabled?: boolean;
  pending?: boolean;
}

export function EndTurnButton({ onClick, disabled, pending }: EndTurnButtonProps) {
  return (
    <Button type="button" onClick={onClick} disabled={disabled} size="lg">
      {pending ? "Ending turn…" : "End Turn"}
    </Button>
  );
}
